import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CustomModal from './customModal'
import ContainedButton from '../buttons/containedButton'
import { t } from 'i18next'
import ExclamationPointIcon from '../../../icons/exclamationPointIcon'

interface Props {
  open: boolean
  errorTitle: string
  errorDescription?: string | null
}

export default function BlockedUserModal({ open, errorTitle, errorDescription }: Props) {
  const acqSite = process.env.REACT_APP_ACQ_SITE as string
  return (
    <CustomModal 
      open={open} 
      handleClose={() => window.location.replace(acqSite)} 
      variant="default"
    >
      <Box
        data-flex-container
        sx={{
          width: '100%',
          display: 'flex', 
          flexDirection: 'column',
        }}
      >
        {/* Icon and Title Section */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          gap: '8px', 
          mb: '16px',
        }}>
          <Box>
            <ExclamationPointIcon />
          </Box>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            width: '100%'
          }}>
            <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>
              {errorTitle}
            </Typography>
          </Box>
        </Box>

        {/* Content Section */}
        <Box sx={{ 
          flex: 1, 
          overflow: 'auto',
          mb: '16px',
          textAlign: 'center',
        }}>
          <Typography sx={{ 
            textAlign: 'center', 
            width: '100%',
            lineHeight: '24px',
            fontSize: {
              xs: '14px',
              md: '16px',
            },
            mb: '24px',
          }}>
            {errorDescription === 'user is blocked' ? t('common.accountBlocked') : t('common.tryLater')}
            {t('common.contactAdmin')}
          </Typography>
        </Box>

        {/* Actions Section */}
        <Box
          sx={{
            borderTop: '1px solid #e0e0e0',
            padding: {
              xs: '16px',
              sm: '20px', 
              md: '24px',
            },
            marginTop: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            gap: {
              xs: '12px',
              sm: '16px',
              md: '20px',
            },
          }}
        >
          <ContainedButton
            handleClick={() => window.location.replace(acqSite)}
            variant='secondary'
            title={t('common.backHomePage')}
          />
        </Box>
      </Box>
    </CustomModal>
  )
}
